function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "DESKTOP",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "2.5.---Kalkulator-zu\u017Cycia-wody",
  transform: "translate(-926.000000, -1096.000000)"
}, React.createElement("rect", {
  fill: "none",
  x: 0,
  y: 0,
  width: 1920,
  height: 1747
}), React.createElement("g", {
  id: "kalkulatort",
  transform: "translate(0.000000, 357.000000)"
}, React.createElement("rect", {
  id: "Rectangle",
  fill: "none",
  x: 0,
  y: 0,
  width: 1920,
  height: 1969
}), React.createElement("g", {
  id: "sekcja-1",
  transform: "translate(615.000000, 39.000000)"
}, React.createElement("g", {
  id: "uprawa-copy",
  transform: "translate(1.000000, 592.000000)"
}, React.createElement("g", {
  id: "produkcja",
  transform: "translate(240.000000, 56.000000)"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("g", {
  id: "ico/ceny/wieprzowina",
  transform: "translate(70.000000, 52.303371)",
  fill: "#9B9B9B",
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "currentColor",
  d: "M24.2351953,22.8820972 C24.461552,22.8820972 24.6879086,22.9438604 24.8619082,23.0675055 L24.9596062,23.1491194 L35.5546629,34.899841 C38.8146162,37.8375984 40.6258521,41.7545056 40.6258521,45.849496 C40.6258521,49.9443838 38.8147205,53.7722494 35.5546629,56.6209651 C32.4757602,59.6476615 28.5817649,61.25 24.4162459,61.25 C20.2507269,61.25 16.3567315,59.6475589 13.3684062,56.7099042 C10.3799766,53.861291 8.75,49.9443838 8.75,45.8493934 C8.75,41.8865987 10.276513,38.1737808 13.0834532,35.2759302 L13.3684062,34.9888826 L23.5107845,23.238161 C23.691835,23.0601804 23.9635673,22.9711388 24.2351953,22.8820972 Z M24.1446179,25.1965633 L14.6361774,36.2351573 C12.0100576,38.8167482 10.5611315,42.28855 10.5611315,45.8493934 C10.5611315,49.4102368 12.0100576,52.8820386 14.6361774,55.4636295 C17.2622972,58.0452204 20.7034054,59.4695783 24.4162459,59.4695783 C28.1290863,59.4695783 31.5701945,58.0452204 34.1963143,55.4636295 C37.0940621,52.9710802 38.6335656,49.58832 38.7242474,46.0274766 C38.7242474,42.3775916 37.1847439,38.9057898 34.1964187,36.3241989 C34.1964187,36.3241989 34.1384491,36.3241989 34.1152613,36.2786096 L34.1058412,36.2351573 L24.1446179,25.1965633 Z M15.9945261,37.3923904 C16.3567315,37.0363265 16.9000918,37.0363265 17.2622972,37.3923904 C17.6245027,37.7484542 17.6245027,38.2826012 17.2622972,38.638665 L17.2622972,38.638665 L17.1717198,38.7277066 C15.2701152,40.5971699 14.1833945,43.1787609 14.1833945,45.8493934 C14.1833945,48.5200259 15.2700108,51.0125753 17.1717198,52.9710802 C19.0734288,54.8404409 21.6995486,55.9087349 24.4162459,55.9087349 C24.9596062,55.9087349 25.3218116,56.2647987 25.3218116,56.7989458 C25.3218116,57.3330928 24.8690287,57.6891566 24.4162459,57.6891566 C21.2467657,57.6891566 18.167863,56.4428819 15.9039486,54.2173548 C13.6400342,51.9918277 12.372263,49.054173 12.372263,45.8493934 C12.372263,42.7336554 13.6400342,39.7069591 15.9039486,37.481432 L15.9039486,37.481432 Z M50.1418687,8.99526217 L50.2247656,9.08382907 L57.9220745,18.6980652 C62.3593259,23.0600778 62.3593259,30.62687 57.9219702,35.6119687 C55.5674783,37.8374958 52.5791531,38.9947288 49.5002504,38.9947288 C46.4213477,38.9947288 43.4330224,37.8374958 41.0785306,35.6119687 C36.7177836,31.0627448 36.6425983,23.6761922 40.8529747,18.9446144 L41.0785306,18.6980652 L48.7758395,9.08382907 C49.1121731,8.67051689 49.7609065,8.64099459 50.1418687,8.99526217 Z M49.5002504,11.0422314 L42.4368792,19.7662566 C38.6334613,23.861247 38.5429882,30.3597452 42.4368792,34.365694 C46.3307702,38.1935596 52.6697305,38.1935596 56.654199,34.365694 C60.3884639,30.1704134 60.4563596,23.8297981 56.8578862,20.0619465 L56.654199,19.8552982 L56.5636215,19.7662566 L49.5002504,11.0422314 Z M45.0631034,21.0126339 C45.395125,21.3390257 45.4227935,21.8150569 45.1461088,22.1663886 L45.0631034,22.2589086 L44.9725259,22.3479502 C42.4369836,25.0185827 42.4369836,29.2915537 44.8819485,31.9621863 C46.0592466,33.1194193 47.6892232,33.742608 49.4097773,33.742608 C49.9530333,33.742608 50.315343,34.0987744 50.315343,34.6329214 C50.315343,35.1670684 50.0437151,35.4340906 49.5003547,35.4340906 C47.3270178,35.4340906 45.2442583,34.6329214 43.7047548,33.1195219 C40.6013054,29.894322 40.6234929,24.6207296 43.5162168,21.3102763 L43.7047548,21.1016755 L43.7953322,21.0126339 C44.1575376,20.6565701 44.700898,20.6565701 45.0631034,21.0126339 Z",
  id: "Combined-Shape"
})))))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "70px",
    height: "71px",
    viewBox: "0 0 70 71",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/wilgotnosc_srednia.0cb664f1.svg";
export { SvgComponent as ReactComponent };